import React, { useState, useEffect } from 'react';

import TextField from '@material-ui/core/TextField';
import Modal from 'components/Tvendo/Common/ModalBase';
import Autocomplete from '@material-ui/lab/Autocomplete';
import moment from 'moment';
import { WithApp } from 'contexts/appContext';
import { wsGetAll } from 'services/WService.js';

const ZONALES = ['NORTE', 'SUR'];
const tipos = [
  { code: 'O', label: 'Venta' },
  { code: 'C', label: 'Cobertura' },
];

export default WithApp(function ModalCuotaZonal(props) {
  const cuota = props.model;
  const periodo = moment(cuota.valueSearch?.Periodo).format('YYYY-MM');

  const [dataChanging, setDataChanging] = useState([]);
  const [divisions, setDivisions] = useState([]);

  function handleChange(field, value) {
    setDataChanging((prev) => ({ ...prev, [field]: value }));
  }

  async function listDivisions() {
    let response = await wsGetAll('sale/arcor_divisions');
    if (response.success) setDivisions(response.data);
  }

  useEffect(() => {
    if (cuota.open) {
      setDataChanging({
        ...(cuota.zonal ? { zonal: cuota.zonal } : {}),
        type: cuota.type,
        sale_arcor_division_id: cuota.sale_arcor_division_id,
      });
      listDivisions();
    }
  }, [cuota.open]);

  return (
    <>
      <Modal
        title={`Nueva cuota de zonal arcor`}
        model={cuota}
        setOpen={props.setOpen}
        showNotify={props.showNotify}
        reload={props.reload}
        arrDataResponse
        entity='sale/arcor_quota_zones'
        dataForce={{
          zonal: dataChanging.zonal,
          type: dataChanging.type,
          sale_arcor_division_id: dataChanging.sale_arcor_division_id,
        }}
      >
        <TextField
          label="Periodo"
          fullWidth
          type="month"
          name="Periodo"
          margin="normal"
          defaultValue={periodo || ''}
          InputLabelProps={{ shrink: true }}
          inputProps={{ readOnly: true }}
          required
        />
        <Autocomplete
          disableClearable
          options={ZONALES}
          getOptionLabel={(item) => `${item}`}
          renderInput={(params) => (
            <TextField {...params} label="Zonal" margin="normal" fullWidth />
          )}
          onChange={(e, item) => { handleChange('zonal', item); }}
          value={ZONALES.find((z) => z === dataChanging.zonal) || null}
          style={{ flexGrow: 1, marginRight: '10px' }}
        />
        <Autocomplete
          disableClearable
          options={tipos}
          getOptionLabel={(item) => item.label}
          renderInput={(params) => (
            <TextField {...params} label="Tipo" margin="normal" fullWidth />
          )}
          onChange={(e, item) => { handleChange('type', item?.code); }}
          value={tipos.find((t) => t.code === dataChanging.type) || null}
          style={{ flexGrow: 1, marginRight: '10px' }}
        />
        <Autocomplete
          disableClearable
          options={divisions}
          getOptionLabel={(item) => item.description}
          renderInput={(params) => (
            <TextField {...params} label="División" margin="normal" fullWidth />
          )}
          onChange={(e, item) => { handleChange('sale_arcor_division_id', item?.id); }}
          value={divisions.find((d) => String(d.id) === String(dataChanging.sale_arcor_division_id)) || null}
          style={{ flexGrow: 1, marginRight: '10px' }}
        />
        <TextField
          label="Cuota"
          fullWidth
          type="number"
          name="quota"
          margin="normal"
          defaultValue={!!cuota ? cuota.quota : ''}
          required
        />
      </Modal>
    </>
  );
});
